import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { initialDataList } from '@interfaces/common/common.Interface'

export interface MangXaHoiState {
  baiVietList?: any
  baiVietChiTiet?: any
  binhLuanList?: any
  camXucList?: any
  taiLieuList?: any
  baoCaoList?: any
  reloadMangXaHoiList?: string | null
}

const initialState: MangXaHoiState = {
  baiVietList: initialDataList,
  baiVietChiTiet: {},
  binhLuanList: initialDataList,
  camXucList: initialDataList,
  taiLieuList: initialDataList,
  baoCaoList: initialDataList,
  reloadMangXaHoiList: null,
}

export const mangXaHoiDucks = createSlice({
  name: 'mangXaHoi',
  initialState,
  reducers: {
    // Bài viết
    layDanhSachBaiViet: (state: RootState, action: PayloadAction<any>) => {
      state.baiVietList = { loading: true, queryStr: action.payload }
    },
    layDanhSachBaiVietThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.baiVietList = { loading: false, ...action.payload }
    },
    layDanhSachBaiVietThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.baiVietList = { loading: false, ...action.payload }
    },

    layChiTietBaiViet: (state: RootState, action: PayloadAction<any>) => {
      state.baiVietChiTiet = { loading: true, id: action.payload }
    },
    layChiTietBaiVietThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.baiVietChiTiet = { loading: false, ...action.payload }
    },
    layChiTietBaiVietThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.baiVietChiTiet = { loading: false, ...action.payload }
    },

    // Bình luận
    layDanhSachBinhLuan: (state: RootState, action: PayloadAction<any>) => {
      state.binhLuanList = { loading: true, queryStr: action.payload }
    },
    layDanhSachBinhLuanThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.binhLuanList = { loading: false, ...action.payload }
    },
    layDanhSachBinhLuanThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.binhLuanList = { loading: false, ...action.payload }
    },

    // Cảm xúc
    layDanhSachCamXuc: (state: RootState, action: PayloadAction<any>) => {
      state.camXucList = { loading: true, queryStr: action.payload }
    },
    layDanhSachCamXucThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.camXucList = { loading: false, ...action.payload }
    },
    layDanhSachCamXucThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.camXucList = { loading: false, ...action.payload }
    },

    // Tài liệu
    layDanhSachTaiLieu: (state: RootState, action: PayloadAction<any>) => {
      state.taiLieuList = { loading: true, queryStr: action.payload }
    },
    layDanhSachTaiLieuThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.taiLieuList = { loading: false, ...action.payload }
    },
    layDanhSachTaiLieuThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.taiLieuList = { loading: false, ...action.payload }
    },

    // Báo cáo
    layDanhSachBaoCao: (state: RootState, action: PayloadAction<any>) => {
      state.baoCaoList = { loading: true, queryStr: action.payload }
    },
    layDanhSachBaoCaoThanhCong: (state: RootState, action: PayloadAction<any>) => {
      state.baoCaoList = { loading: false, ...action.payload }
    },
    layDanhSachBaoCaoThatBai: (state: RootState, action: PayloadAction<any>) => {
      state.baoCaoList = { loading: false, ...action.payload }
    },

    datTaiLaiDanhSachMangXaHoi: (state: RootState) => {
      state.reloadMangXaHoiList = String(Date.now())
    },
  },
})

export const {
  layDanhSachBaiViet,
  layDanhSachBaiVietThanhCong,
  layDanhSachBaiVietThatBai,
  layChiTietBaiViet,
  layChiTietBaiVietThanhCong,
  layChiTietBaiVietThatBai,
  layDanhSachBinhLuan,
  layDanhSachBinhLuanThanhCong,
  layDanhSachBinhLuanThatBai,
  layDanhSachCamXuc,
  layDanhSachCamXucThanhCong,
  layDanhSachCamXucThatBai,
  layDanhSachTaiLieu,
  layDanhSachTaiLieuThanhCong,
  layDanhSachTaiLieuThatBai,
  layDanhSachBaoCao,
  layDanhSachBaoCaoThanhCong,
  layDanhSachBaoCaoThatBai,
  datTaiLaiDanhSachMangXaHoi,
} = mangXaHoiDucks.actions

export default mangXaHoiDucks.reducer
